import { FC, ReactNode } from 'react';

import { LucideIcon } from 'lucide-react';

import { cn } from '../../utils';
import { Card, CardContent } from '../ui/Card';

interface AnalyticsCardItem {
    label: string;
    value: ReactNode;
    icon: LucideIcon;
    iconWrapperClassName?: string;
    iconClassName?: string;
    testId?: string;
}

interface Props {
    items: AnalyticsCardItem[];
}

export const AnalyticsCardsRow: FC<Props> = ({ items }) => {
    return (
        <div className="mb-4 flex flex-wrap gap-2">
            {items.map(
                ({
                    label,
                    value,
                    icon: Icon,
                    iconWrapperClassName,
                    iconClassName,
                    testId,
                }) => (
                    <Card
                        key={label}
                        className="min-w-[120px] flex-1"
                        data-testid={testId}
                    >
                        <CardContent className="flex items-center gap-2 p-3">
                            <div
                                className={cn(
                                    'rounded-full p-1.5',
                                    iconWrapperClassName,
                                )}
                            >
                                <Icon
                                    className={cn('h-3.5 w-3.5', iconClassName)}
                                />
                            </div>
                            <div>
                                <p
                                    className="text-xs text-muted-foreground"
                                    data-testid={
                                        testId ? `${testId}-label` : undefined
                                    }
                                >
                                    {label}
                                </p>
                                <p
                                    className="text-base font-semibold"
                                    data-testid={
                                        testId ? `${testId}-value` : undefined
                                    }
                                >
                                    {value}
                                </p>
                            </div>
                        </CardContent>
                    </Card>
                ),
            )}
        </div>
    );
};
